import {
  ListNotificationDto,
  ListProjectDto,
  UpdateChangeDtoStatusEnum,
} from '@codefluegel/zeta-change-typescript-client';
import List from '@mui/material/List';
import Modal from '@mui/material/Modal';
import { observer } from 'mobx-react-lite';
import { useAuth } from 'react-oidc-context';
import { useUserApiFactory } from '../../ApiClient';
import NotificationCard from '../NotificationPanel/NotificationCard/NotificationCard';
import NotificationPanel from '../NotificationPanel/NotificationPanel';

const modalStyle = {
  position: 'relative',
  top: '5%',
  left: '70%',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 8, // Use a softer shadow
  borderRadius: 2, // Add rounded corners
  p: 2, // Increase padding inside the modal
  maxHeight: '90%',
  overflowY: 'auto',
  '@media screen and (max-width: 480px)': {
    left: '0',
    width: '100%', // Take up the full width on mobile
    top: '0', // Start from the top
    height: '100%', // Take up the full height on mobile
    borderRadius: 0, // No border-radius for full-screen view
  },
};

const NotificationModal = observer(
  ({
    notifications,
    onClose,
    open,
    projects,
  }: {
    notifications: ListNotificationDto[];
    onClose: (url: string) => void;
    open: boolean;
    projects: ListProjectDto[];
  }) => {
    const userApi = useUserApiFactory();
    const auth = useAuth();
    const user = auth.user?.profile.email?.toLocaleLowerCase();

    const markAllAsRead = async () => {
      try {
        if (user)
          await userApi.usersControllerMarkAllNotificationsRead({ id: user });
        onClose('');
      } catch (e) {
        console.log(e);
      }
    };

    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <List sx={modalStyle}>
          <NotificationPanel onRead={markAllAsRead} isNavigationBar>
            {notifications.map(notification => (
              <NotificationCard
                key={notification.id}
                read={notification.read}
                Title={notification.changeRequest.title || ''}
                ChangeNoClient={notification.changeRequest.changeNoClient || ''}
                ChangeNo={notification.changeRequest.changeNo || ''}
                NotificationId={notification.id}
                ProjectId={
                  projects.find(
                    project =>
                      project.id === notification.changeRequest.projectId,
                  )?.name || ''
                }
                navigateToChange={url => onClose(url)}
                ChangeId={notification.changeRequest.id.toString()}
                Status={
                  (notification.changeRequest
                    .status as UpdateChangeDtoStatusEnum) || ''
                }
              />
            ))}
          </NotificationPanel>
        </List>
      </Modal>
    );
  },
);

export default NotificationModal;
